// extracted by mini-css-extract-plugin
export default {"card":"Card_card__sxF0b","bubble":"Card_bubble__IY9Uu","image":"Card_image__iiXkJ","title":"Card_title__zthR+","socials":"Card_socials__lxRD2","desc":"Card_desc__MRDfU"};